import { connect } from 'react-redux';
import selectors from '../../rootSelectors';
import AppErrorView from './AppErrorView';
import { clearAppError } from '../api/apiCallActions';
import { retryGetRequestAction } from '../api/apiRetryGetActions';
import {setIsFileLoadingFailed, unblockScreen} from '../screen/screenActions';
import { handleAuthenticationFailed, logUserOut } from '../user/userActions';
import { syncOfflineResults } from '../start/startActions';
import { goToInterstitial } from '../navigation/navigationActions';
import { getOnlineStatus } from '../utils/offlineUtils';
import { clearSecureBrowserError } from '../secureBrowser/secureBrowserActions';
import { STUDENT_HOME } from '../../constants/secureBrowser';

const mapStateToProps = (state) => ({
    appLevelErrorStatus: selectors.getAppLevelErrorStatus(state),
    isFileLoadingFailed: selectors.getIsFileLoadingFailed(state),
    isLanternUser: selectors.getIsLanternUser(state),
    secureBrowserError: selectors.getSecureBrowserError(state),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    onRetry: () => {
        dispatch(retryGetRequestAction());
    },
    onPageReload: () => {
        dispatch(setIsFileLoadingFailed(false));
        ownProps.pageReloadCallback();
    },
    onAuthenticationFailed: () => {
        dispatch(clearAppError());
        handleAuthenticationFailed();
    },
    logUserOut: () => {
        dispatch(clearAppError());
        logUserOut();
    },
    syncOfflineResultsAndContinue: async () => {
        const isOnline = await getOnlineStatus();
        if (isOnline) {
            await dispatch(syncOfflineResults());
            dispatch(unblockScreen());
            dispatch(goToInterstitial());
        }
    },
    goToHomeScreen: () => {
        dispatch(clearSecureBrowserError());
        window.location.assign(STUDENT_HOME);
    },
});

const AppErrorContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(AppErrorView);

export default AppErrorContainer;
